var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 4.01742C1.66602 2.71931 2.71834 1.66699 4.01644 1.66699H6.81921C7.46302 1.66699 8.0346 2.07896 8.23818 2.68973L9.51837 6.53028C9.75375 7.23643 9.43407 8.0082 8.76831 8.34108L7.40928 9.0206C8.22321 10.5315 9.46817 11.7765 10.9791 12.5904L11.6586 11.2314C11.9915 10.5656 12.7632 10.2459 13.4694 10.4813L17.3099 11.7615C17.9207 11.9651 18.3327 12.5367 18.3327 13.1805V15.9832C18.3327 17.2813 17.2804 18.3337 15.9823 18.3337H15.1276C7.69295 18.3337 1.66602 12.3067 1.66602 4.87212V4.01742ZM4.01644 2.94904C3.4264 2.94904 2.94807 3.42737 2.94807 4.01742V4.87212C2.94807 11.5987 8.40101 17.0516 15.1276 17.0516H15.9823C16.5723 17.0516 17.0506 16.5733 17.0506 15.9832V13.1805C17.0506 13.0885 16.9918 13.0068 16.9045 12.9778L13.064 11.6976C12.9631 11.6639 12.8528 11.7096 12.8053 11.8047L11.8407 13.734C11.6868 14.0417 11.3175 14.1731 11.0038 14.0317C8.7718 13.0254 6.97432 11.2279 5.96797 8.99585C5.82656 8.68222 5.95795 8.31288 6.26567 8.15902L8.19495 7.19438C8.29006 7.14683 8.33573 7.03657 8.30211 6.9357L7.02192 3.09515C6.99284 3.0079 6.91119 2.94904 6.81921 2.94904H4.01644Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlack);
export default __webpack_public_path__ + "static/media/phone-black.417f193b839fea808c4994967c1c3a44.svg";
export { ForwardRef as ReactComponent };